<template>
  <div class="cmslist">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <template  v-for="(item, index) in breadData">
          <el-breadcrumb-item :key="index" :to="item.url?item.url:''" v-if="item.name!='首页内容'"><a>{{item.name}}</a></el-breadcrumb-item>
        </template>
      </el-breadcrumb>
      <div class="left_and_right_container">
        <div class="container_left">
          <!-- <news-list-item specialTagName="推荐"></news-list-item> -->
          <!-- <news-list-item specialTagName=""></news-list-item> -->
          <news-list-item
            :specialTagName="
              item.extra_data.length > 1
                ? item.extra_data[1].value
                : item.extra_data[0].value
            "
            v-for="(item, index) in newsListData"
            :key="index"
            :NewsItemData="item"
            @click.native="itemClickFun(item)"
          ></news-list-item>
        </div>
        <div class="container_right">
          <el-input
            placeholder="请输入内容"
            v-model="searchdata"
            clearable
            class="container_right_search"
            prefix-icon="el-icon-search"
            @keypress.native.enter="searchFun"
          >
          </el-input>
          <CmsRecommend></CmsRecommend>
        </div>
      </div>
    </div>
    <DeBounce :fetch-fun="getNewsItemlist" :pagefetchflag="pagefetchflag"></DeBounce>
  </div>
</template>
<script>
import NewsListItem from "@/components/listItem/NewsListItem";
import DeBounce from "@/components/DeBounce";
import CmsRecommend from "@/page/index/cms/CmsRecommend";
export default {
  name: "CmsList",
  data() {
    return {
      searchdata: "", //搜索框model
      newsListData: [],
      breadData: [{name:""}],
      pagefetchflag:true,
      listParams:{
        p:1,
        step:20,
        cate_id: this.$route.query.id,
        keywords:''
      }
    };
  },
  components: {
    NewsListItem,
    DeBounce,
    CmsRecommend
  },
  mounted() {
    // console.log(".............0",this.$store.state.breadPath)
    this.getNewsItemlist();
    // if(this.$route.query.id==97){
    //   this.getStoreBread(97)
    // }else if(this.$route.query.id==115){
    //   this.getStoreBread(115)
    // }
      this.getStoreBread(this.$route.query.id)
  },
  methods: {
    //获取面包屑的内容
    getStoreBread(cate_id) {
      var that = this;
      that.$api.get(
        "/api/cms/breadList",
        {
          cate_id: cate_id,
        },
        (res) => {
          that.breadData = res.data;
          that.breadData.some(item=>{
            if (item.url) {
              item.url = eval('('+item.url+')');
            }
          })
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    //新闻条点击事件
    itemClickFun(val) {
      this.$router.push({ path: "/cmsdetail", query: { id: val.id } });
    },
    searchFun() {
      // if(this.searchdata.trim()==''){
      //   this.$message({type:"error",message:"搜索内容为空！"})
      //   return;
      // }
      this.listParams.keywords = this.searchdata;
      this.listParams.p=1;
       this.pagefetchflag=true;
      this.newsListData=[]
      this.getNewsItemlist();
      // this.$message({ type: "success", message: "查询成功" });
    },
    //获取新闻列表
    getNewsItemlist() {
      const that = this;
      that.$api.get(
        "/api/cms/helpList",
        this.listParams,
        (res) => {
          if(this.listParams.p==1){
            that.newsListData = res.data.list;
          }else{
            if(res.data.list&&res.data.list.length<this.listParams.step){
              this.pagefetchflag = false; 
              // this.$message.success("已加载全部！");
            }
            that.newsListData = that.newsListData.concat(res.data.list);
          }
          if(this.pagefetchflag){
            this.listParams.p+=1;
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
  watch: {
    $route: {
      handler() {
        this.listParams.p=1;
        this.listParams.cate_id=this.$route.query.id;
        this.listParams.keywords=""
        this.pagefetchflag=true;
        this.getNewsItemlist();
        // console.log("this.$route.",this.$route.query.id);
        // this.getCateTargetFun();
        // if (this.$route.query.id == 97) {
        //   this.getStoreBread(97);
        // } else if (this.$route.query.id == 115) {
        //   this.getStoreBread(115);
        // }
        this.getStoreBread(this.$route.query.id)
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.cmslist {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
  padding-bottom: 50px;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  // height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 910px;
    min-height: 1142px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 40px;
    padding: 16px 45px 0 30px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .container_right {
    width: 306px;
    .container_right_search {
      width: 100%;
      height: 44px;
      margin-bottom: 11px;
      /deep/.el-input__inner {
        height: 44px;

        border-radius: 22px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// CmsList.vue?0ecebacc